import { useState } from "react";
import {
  Box,
  TextField,
  Grid,
  Stack,
  Paper,
  IconButton,
  Autocomplete,
  Collapse,
  Snackbar,
  Alert,
  Slide,
  Chip,
} from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";
import axios from "../../../config/axios";
import CommonDialog from "../../../components/CommonDialog";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import FormLabel from "../../../components/FormLabel";

const AddToolModal = (props) => {
  // page states
  const [toolName, setToolName] = useState([]);
  const [name, setName] = useState("");
  const [successMsg, setSuccessMsg] = useState(false);

  const [newTools, setNewTools] = useState(false);
  const [validation, setValidation] = useState({
    tool: { status: false, msg: "" },
  });

  // other functions
  const handleSubmit = () => {
    if (isFormValid(toolName)) {
      props.setOpen({ ...props.open, addTool: false });
      const tempData = props.employeeData?.tools;
      const tools = toolName.map((tool) => ({
        name: tool.name,
        value: 75,
      }));
      tempData.push(...tools);
      props.setEmployeeData({ ...props.employeeData, tools: [...tempData] });
      setToolName([]);
    }
  };

  const isFormValid = (toolName) => {
    if (!toolName || !toolName.length) {
      setValidation(() => ({
        ...validation,
        tool: { status: true, msg: "Required" },
      }));
      return false;
    }
    return true;
  };

  const addTools = async () => {
    try {
      const response = await axios.post("/admin/tools", { name: name });

      if (response.data.status) {
        setName("");
        setNewTools(false);
        setSuccessMsg(true);
        props.fetchToolsList();
      } else {
        if (response.data.type === "validation") {
          setValidation(() => ({
            ...validation,
            tool: { status: true, msg: "Required" },
          }));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <CommonDialog
        open={props.open.addTool}
        title={props.title || "Add Tool"}
        submitLabel={newTools ? "Add Tools" : "Submit"}
        onSubmit={() => (newTools ? addTools() : handleSubmit())}
        onClose={() => props.setOpen({ ...props.open, addTool: false })}
      >
        <Paper style={{ ...props.style, width: "100%" }} elevation={0}>
          <Box sx={{ padding: "10px" }}>
            <Stack spacing={1}>
              <Grid container alignItems={"end"}>
                <Grid xs={11} sm={11} md={11} lg={11} xl={11} item>
                  <FormLabel title="Tools & Technology" />
                  <Autocomplete
                    id="size-small-outlined"
                    size="small"
                    options={props.toolsList}
                    multiple
                    getOptionLabel={(option) => option.name}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => (
                        <Chip
                          sx={{ fontWeight: "500" }}
                          label={option.name}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        // label="Tools & Tech"
                        placeholder="Favorites"
                      />
                    )}
                    onChange={(_, value) => setToolName(value)}
                  />
                </Grid>
                <Grid xs={1} sm={1} md={1} lg={1} xl={1} item textAlign={"end"}>
                  <IconButton
                    size="small"
                    onClick={() => {
                      setNewTools((pre) => !pre);
                      setValidation({ tool: { status: false, msg: "" } });
                    }}
                    sx={{ paddingTop: "0px" }}
                  >
                    {newTools ? (
                      <RemoveCircleOutlineIcon color="primary" />
                    ) : (
                      <AddCircleOutline color="primary" />
                    )}
                  </IconButton>
                </Grid>
                <Grid xs={11} sm={11} md={11} lg={11} xl={11} item mt={3}>
                  <Collapse in={newTools}>
                    <FormLabel title="Add New Tool" />
                    <TextField
                      placeholder="New tools name"
                      size="small"
                      sx={{ width: "100%" }}
                      error={validation.tool.status}
                      helperText={validation.tool.msg}
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Collapse>
                </Grid>
              </Grid>
            </Stack>
          </Box>
        </Paper>
      </CommonDialog>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={successMsg}
        TransitionComponent={Slide}
        autoHideDuration={2000}
        onClose={() => {
          setSuccessMsg(false);
        }}
      >
        <Alert serverity="success">Tools Add Successfully!</Alert>
      </Snackbar>
    </>
  );
};

export default AddToolModal;
